/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { getUrlSync, IActionContext } from '@msdyn365-commerce/core';
import { getCartState } from '@msdyn365-commerce/global-state';
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';

import { IInvoiceErrorState } from '../b2b-citta-invoices-list';
import { IPayableInvoice } from './invoice-data';

export type ICartActionFailureReason = 'EMPTYINPUT' | 'CARTACTIONFAILED';
export interface IAddInvoicesToCartFailureResult {
    failureReason: ICartActionFailureReason;
}

export const payInvoices = async (
    invoices: IPayableInvoice[],
    actionContext: IActionContext,
    onError: (errorState: IInvoiceErrorState) => void
) => {
    const invoicesToAdd: string[] = invoices.filter(invoice => invoice.canBePaid).map(invoice => invoice.id);

    if (!ArrayExtensions.hasElements(invoicesToAdd)) {
        onError({ errorMessage: '', errorReason: { failureReason: 'EMPTYINPUT' } });
        return;
    }

    const cartState = await getCartState(actionContext);
    const result = await cartState.addInvoicesToCart({ invoiceIds: invoicesToAdd });

    if (result.status !== 'SUCCESS') {
        onError({
            errorMessage: '',
            errorReason: { failureReason: 'CARTACTIONFAILED' },
            otherError: result.errorDetails?.LocalizedMessage,
            errorCode: result.errorDetails?.ErrorResourceId
        });
        return;
    }

    const cartUrl = getUrlSync('cart', actionContext);
    if (cartUrl) {
        window?.location.assign(cartUrl);
    }
};
